<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="消费流水" name="first">
          <div class="searchBar">
            <el-form
                :model="searchParam1"
                status-icon
                ref="searchData"
                label-position="left"
                label-width="90px"
                :inline="true"
            >
              <el-form-item label="">
                <el-input
                    type="text"
                    v-model="searchParam1.name"
                    autocomplete="off"
                    placeholder="请输入消费对象名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                    @change="datetime"
                    v-model="dataVal1"
                    type="datetimerange"
                    align="right"
                    start-placeholder="消费日期"
                    end-placeholder="消费日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-input
                    type="text"
                    v-model="searchParam1.orderId"
                    autocomplete="off"
                    placeholder="请输入订单号"
                ></el-input>
              </el-form-item>
              
              <el-form-item label="" v-if="$getlocalStorage('userData').parentId=='0'">
                <el-input
                    type="text"
                    v-model="searchParam1.username"
                    autocomplete="off"
                    placeholder="请输入消费账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select
                    clearable
                    v-model="searchParam1.sourceType"
                    placeholder="请选择消费平台"
                >
                  <el-option
                      v-for="item in platListState"
                      :key="item.val"
                      :label="item.name"
                      :value="item.val"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="">
                <el-select
                    clearable
                    v-model="searchParam1.businessType"
                    placeholder="请选择类型"
                    filterable
                >
                  <el-option
                      v-for="item in businessTypes"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button
                    type="primary"
                    @click="selectTable('first')"
                >查询
                </el-button
                >
                <el-button
                    type="info"
                    @click="
                        (dataVal1='',searchParam1 = {page: 1,size: 10,type: 1},pageSizeNum1=10),
                            selectTable('first')
                    "
                >重置
                </el-button
                >
                <a :href="exportUrl" target="_blank" style="display:inline-block;margin-left: 10px">
                  <el-button type="primary">导出</el-button>
                </a>

                <el-button
                    type="primary"
                    @click="exportDialog=true"
                    v-if="$getlocalStorage('userData').parentId=='0'"
                >导出历史消费明细
                </el-button
                >

              </el-form-item>
            </el-form>
          </div>
          <ExTable
              :table-list="tableData1"
              :header="header1"
              :isIndex="false"
              height="300"
              :total="total1"
              :tableId="1"
              :activeIndex="searchParam1.page"
              :pageSizeNum="pageSizeNum1"
              @clickPage="clickPage"
              @clickSize="clickSize"
          >
            <el-table-column slot="consumeAmount" label="消费金额" align="center" width="80" v-if="$getlocalStorage('userData').parentId=='0'">
                <template slot-scope="scope">
                    {{scope.row.consumeAmount}}元
                </template>
            </el-table-column>
          </ExTable>
        </el-tab-pane>
        <el-tab-pane label="返还流水" name="second">
          <div class="searchBar">
            <el-form
                :model="searchParam2"
                status-icon
                ref="searchData"
                label-position="left"
                label-width="90px"
                :inline="true"
            >
              <el-form-item label="">
                <el-date-picker
                    @change="datetime"
                    v-model="dataVal2"
                    type="datetimerange"
                    align="right"
                    start-placeholder="返还日期"
                    end-placeholder="返还日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-input
                    type="text"
                    v-model="searchParam2.orderId"
                    autocomplete="off"
                    placeholder="请输入订单号"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                    type="text"
                    v-model="searchParam2.suiteName"
                    autocomplete="off"
                    placeholder="请输入服务包名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="" v-if="$getlocalStorage('userData').parentId=='0'">
                <el-input
                    type="text"
                    v-model="searchParam2.username"
                    autocomplete="off"
                    placeholder="请输入返还账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select
                    clearable
                    v-model="searchParam2.sourceType"
                    placeholder="请选择返还平台"
                >
                  <el-option
                      v-for="item in platListState"
                      :key="item.val"
                      :label="item.name"
                      :value="item.val"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button
                    type="primary"
                    @click="selectTable('second')"
                >查询
                </el-button
                >
                <el-button
                    type="info"
                    @click="
                        (dataVal2='',searchParam2 = {page: 1,size: 10,type: 2},pageSizeNum2=10),
                            selectTable('second')
                    "
                >重置
                </el-button
                >
                <a :href="exportReturnUrl" target="_blank" style="display:inline-block;margin-left: 10px">
                  <el-button type="primary">导出</el-button>
                </a>
              </el-form-item>
            </el-form>
          </div>
          <ExTable
              :table-list="tableData2"
              :header="header2"
              :isIndex="false"
              height="300"
              :total="total2"
              :tableId="2"
              :activeIndex="searchParam2.page"
              :pageSizeNum="pageSizeNum2"
              @clickPage="clickPage"
              @clickSize="clickSize"
          />
        </el-tab-pane>
        <el-tab-pane label="欠费记录" name="third">
          <div class="searchBar">
            <el-form
                :model="searchParam3"
                status-icon
                ref="searchData"
                label-position="left"
                label-width="90px"
                :inline="true"
            >
              <el-form-item label="">
                <el-date-picker
                    @change="datetime"
                    v-model="dataVal3"
                    type="datetimerange"
                    align="right"
                    start-placeholder="欠费日期"
                    end-placeholder="欠费日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="" v-if="$getlocalStorage('userData').parentId=='0'">
                <el-input
                    type="text"
                    v-model="searchParam3.loginName"
                    autocomplete="off"
                    placeholder="请输入欠费账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button
                    type="primary"
                    @click="selectTable('third')"
                >查询
                </el-button
                >
                <el-button
                    type="info"
                    @click="
                                        (dataVal3='',searchParam3 = {page: 1,size: 10},pageSizeNum3=10),
                                            selectTable('third')
                                    "
                >重置
                </el-button
                >
                <!-- <a :href="exportReturnUrl" target="_blank" style="display:inline-block;margin-left: 10px"><el-button type="success">导出</el-button></a> -->
              </el-form-item>
            </el-form>
          </div>
          <ExTable
              :table-list="tableData3"
              :header="header3"
              :isIndex="false"
              height="300"
              :total="total3"
              :tableId="3"
              :activeIndex="searchParam3.page"
              :pageSizeNum="pageSizeNum3"
              @clickPage="clickPage"
              @clickSize="clickSize"
          />
        </el-tab-pane>
        <el-tab-pane label="转出记录" name="four" v-if="isShow2">
          <div class="searchBar">
            <el-form
                :model="searchParam4"
                status-icon
                ref="searchData"
                label-position="left"
                label-width="90px"
                :inline="true"
            >
              <el-form-item label="">
                <el-date-picker
                    @change="datetime"
                    v-model="dataVal4"
                    type="datetimerange"
                    align="right"
                    start-placeholder="消费日期"
                    end-placeholder="消费日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-input
                    type="text"
                    v-model="searchParam4.orderId"
                    autocomplete="off"
                    placeholder="请输入订单号"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                    type="text"
                    v-model="searchParam4.suiteName"
                    autocomplete="off"
                    placeholder="请输入服务包名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button
                    type="primary"
                    @click="selectTable('four')"
                >查询
                </el-button
                >
                <el-button
                    type="info"
                    @click="
                                        (dataVal4='',searchParam4 = {page: 1,size: 10,type: 4},pageSizeNum4=10),
                                            selectTable('four')
                                    "
                >重置
                </el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <ExTable
              :table-list="tableData4"
              :header="header4"
              :isIndex="false"
              height="300"
              :total="total4"
              :tableId="4"
              :activeIndex="searchParam4.page"
              :pageSizeNum="pageSizeNum4"
              @clickPage="clickPage"
              @clickSize="clickSize"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
        title="导出历史消费明细"
        :visible.sync="exportDialog"
        width="612px"
        class="exportDialog"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        center
        @close="closeDia"
    >
      <p>注：当前支持2021.11.13之前在权利卫士，证据平台及知识产权平台的消费情况，由于历史数据比较庞大，默认每人仅可支持导出3次，提交后，系统会在24小时内发送至您下方的邮箱，请注意查收！下载后请妥善保管。</p>
      <el-form :model="exportForm" status-icon :rules="rules" ref="exportForm" label-width="100px" class="exportForm">
        <el-form-item label="请输入邮箱" prop="email">
          <el-input type="text" v-model="exportForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="邮箱验证码" prop="yzm" class="yzm-item">
          <el-input type="text" v-model="exportForm.yzm" autocomplete="off" placeholder="请输入邮箱验证码"></el-input>
          <span class="getyzm" :disabled="disabled" @click="getVerificationCode">{{ yzmtext }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="closeDia">取 消</el-button>
                <el-button type="primary" @click="submitDialogForm('exportForm')">确 定</el-button>
            </span>
    </el-dialog>
    <div id="captcha-element"></div>
  </el-row>
</template>
<script>
import ExTable from "@com/ExTable";
import qs from 'qs'
import {orderTransactionList, oweList, sendMailCode, exportRecord, userOrderOutflow} from "@http/overview/index";
import {formatDate, filterParams, sourceType, businessTypeInfo} from "@/utils/filter";
import NoTrace from '@/utils/noTrace';
import {mapState} from 'vuex'
var interval = null;
export default {
  name: "overview",
  data() {
    var email = (rule, value, callback) => {
      let reg = new RegExp(
          "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
      );
      if (!reg.test(value)) {
        callback(new Error("邮箱格式不正确"));
      }
      callback();
    };
    return {
      isShow2: false,
      exportUrl: '',
      exportReturnUrl: '',
      activeName: "first",
      tabList:[
        {
          name:'first',
          val:1
        },
        {
          name:'second',
          val:2
        },
        {
          name:'third',
          val:3
        },
        {
          name:'four',
          val:4
        },
      ],
      isShow: false,
      dataVal1: "",
      dataVal2: "",
      dataVal3: "",
      dataVal4: "",
      pageSizeNum1: 10,
      pageSizeNum2: 10,
      pageSizeNum3: 10,
      pageSizeNum4: 10,
      //消费流水
      searchParam1: {
        page: 1,
        size: 10,
        type: 1,
        startCreatedAt: "",
        endCreatedAt: "",
        orderId: "",
        suiteName: "",
        username: "",
        sourceType: "",
      },
      tableData1: [],
      header1: [
        {minWidth: 95, prop: "id", label: "消费流水号"},
        {
          minWidth: 80,
          prop: "username",
          label: "消费账号",
        },
        //     formatter: (row) => {
        //   return businessTypeInfo(row.sourceType);
        // },
        {
          minWidth: 80,
          prop: "name",
          label: "消费对象",

        },
        {
          prop: "tsCount",
          label: "消费时间戳个数",
          width: 120,
          formatter: (row) => {
            return row.tsCount + "个";
          },
        },
        {
            minWidth:80,
            slot: 'consumeAmount'
        },
        {
          minWidth: 80,
          prop: "sourceTypeName",
          label: "消费平台",
        },
        {
            width:80,
            prop: "partnerName",
            label: "合作方",
        },
        {
          minWidth: 80,
          prop: "businessTypeName",
          label: "类型",
        },
        {
          prop: "createdAt",
          minWidth: 90,
          label: "消费时间",
          formatter: (row) => {
            return formatDate(row.createdAt);
          },
        },
        {
          prop: "orderId",
          minWidth: 100,
          label: "关联订单号",
        },
        // {
        //   width: 100,
        //   prop: "suiteName",
        //   label: "服务包名称",
        // },
        {
          width: 180,
          prop: "orderTsCount",
          label: "订单时间戳总数/剩余数",
          formatter: (row) => {
            return row.orderTsCount + "个" +'/'+ row.orderRemainCount + "个";
          },
        },
        // {
        //   width: 180,
        //   prop: "orderRemainCount",
        //   label: "剩余数",
        //   formatter: (row) => {
        //     return row.orderRemainCount + "个";
        //   },
        // },
        {
          width: 80,
          prop: "suiteValidityPeriod",
          label: "有效期",
          formatter: (row) => {
            if (
                row.suiteValidityPeriod == 0 ||
                !row.suiteValidityPeriod
            ) {
              return "永久有效";
            } else {
              return row.suiteValidityPeriod + "天";
            }
          },
        },
        {
          minWidth: 80,
          prop: "extra",
          label: "取证时长",
          formatter: (row) => {
            if (row.extra && JSON.parse(row.extra).proofTimeLength) {
              return JSON.parse(row.extra).proofTimeLength;
            } else {
              return "--"
            }

          },
        },
        {
          minWidth: 80,
          prop: "extra",
          label: "存储时长",
          formatter: (row) => {
            if (row.extra && JSON.parse(row.extra).storeDays) {
              return JSON.parse(row.extra).storeDays+'天';
            } else {
              return "--"
            }

          },
        },
        {
          minWidth: 100,
          prop: "oweId",
          label: "备注",
          formatter: (row) => {
            if (row.oweId) {
              return '偿还欠费流水号' + row.oweId
            } else {
              return "--"
            }

          },
        },
      ],
      total1: 10,
      //返还流水
      searchParam2: {
        page: 1,
        size: 10,
        type: 2,
        startCreatedAt: "",
        endCreatedAt: "",
        orderId: "",
        suiteName: "",
        username: "",
        sourceType: "",
      },
      tableData2: [],
      header2: [
        {minWidth: 95, prop: "id", label: "返还流水号"},
        {minWidth: 95, prop: "referId", label: "消费流水号"},
        {
          minWidth: 90,
          prop: "createdAt",
          label: "返还时间",
          formatter: (row) => {
            return formatDate(row.createdAt);
          },
        },
        {
          minWidth: 90,
          prop: "orderId",
          label: "订单号",
        },
        {
          width: 100,
          prop: "suiteName",
          label: "服务包名称",
        },
        {
          width: 100,
          prop: "orderTsCount",
          label: "时间戳总数",
          formatter: (row) => {
            return row.orderTsCount + "个";
          },
        },
        {
          width: 80,
          prop: "suiteValidityPeriod",
          label: "有效期",
          formatter: (row) => {
            if (
                row.suiteValidityPeriod == 0 ||
                !row.suiteValidityPeriod
            ) {
              return "永久有效";
            } else {
              return row.suiteValidityPeriod + "天";
            }
          },
        },
        {
          width: 80,
          prop: "tsCount",
          label: "返还个数",
          formatter: (row) => {
            return row.tsCount + "个";
          },
        },
        {
          minWidth: 80,
          prop: "sourceTypeName",
          label: "返还平台",
        },
        {
          minWidth: 80,
          prop: "username",
          label: "返还账号",
        },
        {
          minWidth: 80,
          prop: "name",
          label: "返还对象",
        },
      ],
      total2: 10,
      //欠费记录
      searchParam3: {
        page: 1,
        size: 10,
        startCreatedAt: "",
        endCreatedAt: "",
        loginName: '',
      },
      tableData3: [],
      header3: [
        {
          width: 180,
          prop: "id",
          label: "欠费流水号",
        },
        {
          minWidth: 120,
          prop: "createdAt",
          label: "欠费时间",
          formatter: (row) => {
            return formatDate(row.createdAt);
          },
        },
        {
          minWidth: 120,
          prop: "oweTsCount",
          label: "欠费个数",
          formatter: (row) => {
            return row.oweTsCount + '个';
          },
        },
        {
          minWidth: 120,
          prop: "repaidTsCount",
          label: "已偿还个数",
          formatter: (row) => {
            return row.repaidTsCount + '个';
          },
        },

        {
          minWidth: 120,
          prop: "sourceTypeName",
          label: "欠费平台",
        },
        {
          minWidth: 120,
          prop: "username",
          label: "欠费账号",
        },
        {
          minWidth: 80,
          prop: "name",
          label: "欠费对象",
        },
        {
          minWidth: 100,
          prop: "status",
          label: "欠费状态", // 0  欠费   1 还款
          render: (h, data) => {
            switch (data.row.status) {
              case 0:
                return (<span style="color:#f70f0f">欠费中</span>);
                break;
              case 1:
                return (<span style="color:#4f9e48">已还清</span>);
                break;
            }
          },
        },
      ],
      total3: 10,
      //转出记录
      searchParam4: {
        page: 1,
        size: 10,
        type: 4,
        orderId: "",
        suiteName: "",
        startCreatedAt: "",
        endCreatedAt: "",
      },
      tableData4: [],
      header4: [
        {
          width: 180,
          prop: "id",
          label: "转出流水号",
        },
        {
          minWidth: 120,
          prop: "createdAt",
          label: "转出时间",
          formatter: (row) => {
            return formatDate(row.createdAt);
          },
        },
        {
          prop: "orderId",
          minWidth: 90,
          label: "订单号",
        },
        {
          width: 100,
          prop: "suiteName",
          label: "服务包名称",
        },
        {
          width: 100,
          prop: "orderTsCount",
          label: "时间戳总数",
          formatter: (row) => {
            return row.orderTsCount + "个";
          },
        },
        {
          width: 80,
          prop: "suiteValidityPeriod",
          label: "有效期",
          formatter: (row) => {
            if (
                row.suiteValidityPeriod == 0 ||
                !row.suiteValidityPeriod
            ) {
              return "永久有效";
            } else {
              return row.suiteValidityPeriod + "天";
            }
          },
        },
        {
          prop: "tsCount",
          label: "转出个数",
          width: 80,
          formatter: (row) => {
            return row.tsCount + "个";
          },
        },
        {
          minWidth: 80,
          prop: "inflowAccount",
          label: "转入账号",
        },
      ],
      total4: 10,
      platList: [
        // {
        //     val: 975260,
        //     name: "用户中心",
        // },
        {
          val: 955210,
          name: "时间戳",
        },
        {
          val: 955740,
          name: "电子取证",
        },
        // {
        //     val: 955255,
        //     name: "RA",
        // },
        // {
        //     val: 995280,
        //     name: "经销商前台",
        // },
        // {
        //     val: 915290,
        //     name: "经销商后台",
        // },
        {
          val: 952310,
          name: "知识产权",
        },
        {
          val: 700025,
          name: "邮件认证平台",
        },
        // {
        //     val: 925220,
        //     name: "电子签名",
        // },
        {
          val: 954210,
          name: "权利卫士app",
        },
        {
          val: 700023,
          name: "软著保护平台",
        },
        // {
        //     val: 975281,
        //     name: "维权平台",
        // },
        // {
        //     val: 800001,
        //     name: "天平阳光",
        // },
        // {
        //     val: 801001,
        //     name: "百度",
        // },
      ],
      exportDialog: false,
      yzmtext: "获取验证码",
      disabled: false,
      currentTime: 60,
      exportForm: {
        email: '',
        yzm: '',
      },
      rules: {
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {validator: email, trigger: "blur"}
        ],
        yzm: [
          {required: true, message: '请输入验证码', trigger: 'blur'},

        ],
      },
      nvc:'',
    };
  },
  components: {
    ExTable,
  },
  watch: {
    isShow(newVal) {
      return newVal;
    },
  },
  computed: {
    ...mapState({
      businessTypes: (state) => state.userAccount.businessTypes,
      platListState: (state) => state.userAccount.platListState,
    }),
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },
  async created() {
    if (this.$getlocalStorage('userData').parentId !== '0') {
      this.header1 =
          [
            {minWidth: 95, prop: "id", label: "消费流水号"},
            {
              minWidth: 80,
              prop: "username",
              label: "消费账号",
            },
            {
              minWidth: 80,
              prop: "name",
              label: "消费对象",
            },
            {
              prop: "tsCount",
              label: "消费时间戳个数",
              width: 120,
              formatter: (row) => {
                return row.tsCount + "个";
              },
            },
            {
              minWidth: 80,
              prop: "sourceTypeName",
              label: "消费平台",
            },
            {
                width:80,
                prop: "partnerName",
                label: "合作方",
            },
            {
              minWidth: 80,
              prop: "businessTypeName",
              label: "类型",
            },
            {
              prop: "createdAt",
              minWidth: 90,
              label: "消费时间",
              formatter: (row) => {
                return formatDate(row.createdAt);
              },
            },
            {
              prop: "orderId",
              minWidth: 100,
              label: "关联订单号",
            },
            {
              width: 100,
              prop: "suiteName",
              label: "服务包名称",
            },
            {
              width: 80,
              prop: "suiteValidityPeriod",
              label: "有效期",
              formatter: (row) => {
                if (
                    row.suiteValidityPeriod == 0 ||
                    !row.suiteValidityPeriod
                ) {
                  return "永久有效";
                } else {
                  return row.suiteValidityPeriod + "天";
                }
              },
            },

            {
              minWidth: 80,
              prop: "extra",
              label: "取证时长",
              formatter: (row) => {
                if (row.extra && JSON.parse(row.extra).proofTimeLength) {
                  return JSON.parse(row.extra).proofTimeLength;
                } else {
                  return "--"
                }
              },
            },
            {
                minWidth: 80,
                prop: "extra",
                label: "存储时长",
                formatter: (row) => {
                    if (row.extra && JSON.parse(row.extra).storeDays) {
                    return JSON.parse(row.extra).storeDays+'天';
                    } else {
                    return "--"
                    }

                },
            },
            {
              minWidth: 100,
              prop: "oweId",
              label: "备注",
              formatter: (row) => {
                if (row.oweId) {
                  return '偿还欠费流水号' + row.oweId
                } else {
                  return "--"
                }

              },
            },
            // {
            //   prop: "createdAt",
            //   minWidth: 90,
            //   label: "消费时间",
            //   formatter: (row) => {
            //     return formatDate(row.createdAt);
            //   },
            // },
            // {
            //   prop: "orderId",
            //   minWidth: 90,
            //   label: "订单号",
            // },
            // {
            //   width: 100,
            //   prop: "suiteName",
            //   label: "服务包名称",
            // },
            // {
            //   width: 80,
            //   prop: "suiteValidityPeriod",
            //   label: "有效期",
            //   formatter: (row) => {
            //     if (
            //         row.suiteValidityPeriod == 0 ||
            //         !row.suiteValidityPeriod
            //     ) {
            //       return "永久有效";
            //     } else {
            //       return row.suiteValidityPeriod + "天";
            //     }
            //   },
            // },
            // {
            //   prop: "tsCount",
            //   label: "消费个数",
            //   width: 80,
            //   formatter: (row) => {
            //     return row.tsCount + "个";
            //   },
            // },
            // {
            //   minWidth: 80,
            //   prop: "sourceType",
            //   label: "消费平台",
            //   formatter: (row) => {
            //     return sourceType(row.sourceType);
            //   },
            // },
            //
            // {
            //   minWidth: 60,
            //   prop: "extra",
            //   label: "时长",
            //   formatter: (row) => {
            //     if (row.extra) {
            //       return JSON.parse(row.extra).proofTimeLength;
            //     } else {
            //       return "--"
            //     }
            //
            //   },
            // },
            // {
            //   minWidth: 100,
            //   prop: "oweId",
            //   label: "备注",
            //   formatter: (row) => {
            //     if (row.oweId) {
            //       return '偿还欠费流水号' + row.oweId
            //     } else {
            //       return "--"
            //     }
            //
            //   },
            // },
          ];
      this.header2 =
          [
            {minWidth: 95, prop: "id", label: "返还流水号"},
            {minWidth: 95, prop: "referId", label: "消费流水号"},
            {
              minWidth: 90,
              prop: "createdAt",
              label: "返还时间",
              formatter: (row) => {
                return formatDate(row.createdAt);
              },
            },
            {
              minWidth: 90,
              prop: "orderId",
              label: "订单号",
            },
            {
              width: 100,
              prop: "suiteName",
              label: "服务包名称",
            },
            {
              width: 80,
              prop: "suiteValidityPeriod",
              label: "有效期",
              formatter: (row) => {
                if (
                    row.suiteValidityPeriod == 0 ||
                    !row.suiteValidityPeriod
                ) {
                  return "永久有效";
                } else {
                  return row.suiteValidityPeriod + "天";
                }
              },
            },
            {
              width: 80,
              prop: "tsCount",
              label: "返还个数",
              formatter: (row) => {
                return row.tsCount + "个";
              },
            },


            {
              minWidth: 80,
              prop: "sourceTypeName",
              label: "返还平台",
            },
            {
              minWidth: 80,
              prop: "username",
              label: "返还账号",
            },
            {
              minWidth: 80,
              prop: "name",
              label: "返还对象",
            },
            // {
            //   prop: "tsCount",
            //   label: "消费时间戳个数",
            //   width: 120,
            //   formatter: (row) => {
            //     return row.tsCount + "个";
            //   },
            // },
          ]
    }
    let httpObj =Object.assign({},this.searchParam1)
    if(httpObj.businessType==='EVIDENCE_VIDEO'){
      httpObj.businessType=['EVIDENCE_VIDEO','EVIDENCE_WECHAT']
    }
    this.exportUrl = `/api/orderTransactionLog/export?${qs.stringify(filterParams(httpObj))}`
    this.exportReturnUrl = `/api/orderTransactionLog/export?${qs.stringify(filterParams(this.searchParam2))}`
  
    let tabVal=this.$route.query.tabVal || '';
    if(tabVal && tabVal<5 && tabVal>0){//有参数传过来先判断参数是否合法，然后获取是否有第4个tab
      let res2 = await userOrderOutflow();
      res2?.status == 1 ? this.isShow2 = true : this.isShow2 = false;
    }
    let tabMaxNum=this.isShow2 ? 5 : 4;//第4个tab不一定所有人都有，要判断一下传递的参数是否有效
    if(tabVal && tabVal<tabMaxNum && tabVal>0){
      //切换参数对应tab
      let tabActiveItem = this.tabList.find(obj => obj.val == tabVal);
      this.activeName=tabActiveItem.name;
      let res = await this.getTableData(filterParams(this[`searchParam${tabVal}`]));
      this[`tableData${tabVal}`] = res.data;
      this[`total${tabVal}`] = res.total;
    }else{//没有参数走原逻辑
      let res = await this.getTableData(filterParams(this.searchParam1));
      this.tableData1 = res.data;
      this.total1 = res.total;
      let res2 = await userOrderOutflow();
      res2?.status == 1 ? this.isShow2 = true : this.isShow2 = false;
    }    
  },
  mounted() {
    zhuge.track('用户中心_查看消费流水', {'渠道': this.channelCodeValue})
    NoTrace.init('captcha-element', 'captcha-button')
  },
  beforeDestroy() {
      NoTrace.reset()
  },
  methods: {
    async getTableOwe(data) {
      let res = await oweList(data);
      console.log(res);
      return res;
    },
    async getTableData(data) {
      console.log(data)
      let res = await orderTransactionList(data);
      console.log(res);
      return res;
    },
    async selectTable(name) {
      let res;
      var re = /^[0-9]+.?[0-9]*/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
      if (name == "first") {
        if (this.searchParam1.orderId && !re.test(this.searchParam1.orderId)) {
          this.$msg("订单号输入内容格式不正确，请仔细核对");
          return false;
        }
        this.searchParam1.page = 1;
        let httpObj =Object.assign({},this.searchParam1)
        if(httpObj.businessType==='EVIDENCE_VIDEO'){
          httpObj.businessType=['EVIDENCE_VIDEO','EVIDENCE_WECHAT']
        }
        res = await this.getTableData(filterParams(httpObj));
        this.tableData1 = res.data;
        this.total1 = res.total;
        this.exportUrl = `/api/orderTransactionLog/export?${qs.stringify(filterParams(httpObj))}`
      } else if (name == "second") {
        if (this.searchParam2.orderId && !re.test(this.searchParam2.orderId)) {
          this.$msg("订单号输入内容格式不正确，请仔细核对");
          return false;
        }
        this.searchParam2.page = 1;
        res = await this.getTableData(filterParams(this.searchParam2));
        this.tableData2 = res.data;
        this.total2 = res.total;
        this.exportReturnUrl = `/api/orderTransactionLog/export?${qs.stringify(filterParams(this.searchParam2))}`
      } else if (name == "third") {
        this.searchParam3.page = 1;
        res = await this.getTableOwe(filterParams(this.searchParam3));
        this.tableData3 = res.data;
        this.total3 = res.total;
      } else {
        this.searchParam4.page = 1;
        res = await this.getTableData(filterParams(this.searchParam4));
        this.tableData4 = res.data;
        this.total4 = res.total;
      }
    },
    async handleClick(tab) {
      console.log(tab)
      let res;
      if (tab.name == "first") {
        zhuge.track('用户中心_查看消费流水', {'渠道': this.channelCodeValue})
        if (!(this.tableData1.length > 0)) {
          res = await this.getTableData(
              filterParams(this.searchParam1)
          );
          this.tableData1 = res.data;
          this.total1 = res.total;
        }
      } else if (tab.name == "second") {
        zhuge.track('用户中心_查看返还流水', {'渠道': this.channelCodeValue})
        if (!(this.tableData2.length > 0)) {
          res = await this.getTableData(
              filterParams(this.searchParam2)
          );
          this.tableData2 = res.data;
          this.total2 = res.total;
        }
      } else if (tab.name == "third") {
        zhuge.track('用户中心_查看欠费记录', {'渠道': this.channelCodeValue})
        if (!(this.tableData3.length > 0)) {
          res = await this.getTableOwe(
              filterParams(this.searchParam3)
          );
          this.tableData3 = res.data;
          this.total3 = res.total;
        }
      } else {
        if (!(this.tableData4.length > 0)) {
          res = await this.getTableData(
              filterParams(this.searchParam4)
          );
          this.tableData4 = res.data;
          this.total4 = res.total;
        }
      }
    },
    async clickPage(page, num) {
      let res;
      if (num == 1) {
        this.searchParam1.page = page;
        res = await this.getTableData(filterParams(this.searchParam1));
        this.tableData1 = res.data;
        this.total1 = res.total;
      } else if (num == 2) {
        this.searchParam2.page = page;
        res = await this.getTableData(filterParams(this.searchParam2));
        this.tableData2 = res.data;
        this.total2 = res.total;
      } else if (num == 3) {
        this.searchParam3.page = page;
        res = await this.getTableOwe(filterParams(this.searchParam3));
        this.tableData3 = res.data;
        this.total3 = res.total;
      } else {
        this.searchParam4.page = page;
        res = await this.getTableData(filterParams(this.searchParam4));
        this.tableData4 = res.data;
        this.total4 = res.total;
      }
    },
    async clickSize(size, num) {
      let res;
      if (num == 1) {
        this.searchParam1.page = 1;
        this.searchParam1.size = size;
        this.pageSizeNum1 = size;
        res = await this.getTableData(filterParams(this.searchParam1));
        this.tableData1 = res.data;
        this.total1 = res.total;
      } else if (num == 2) {
        this.searchParam2.page = 1;
        this.searchParam2.size = size;
        this.pageSizeNum2 = size;
        res = await this.getTableData(filterParams(this.searchParam2));
        this.tableData2 = res.data;
        this.total2 = res.total;
      } else if (num == 3) {
        this.searchParam3.page = 1;
        this.searchParam3.size = size;
        this.pageSizeNum3 = size;
        res = await this.getTableOwe(filterParams(this.searchParam3));
        this.tableData3 = res.data;
        this.total3 = res.total;
      } else {
        this.searchParam4.page = 1;
        this.searchParam4.size = size;
        this.pageSizeNum4 = size;
        res = await this.getTableData(filterParams(this.searchParam4));
        this.tableData4 = res.data;
        this.total4 = res.total;
      }
    },
    datetime(e) {
      if (this.activeName == "first") {
        if (e) {
          this.searchParam1.startCreatedAt = e[0];
          this.searchParam1.endCreatedAt = e[1];
        } else {
          this.searchParam1.startCreatedAt = "";
          this.searchParam1.endCreatedAt = "";
        }
      } else if (this.activeName == "second") {
        if (e) {
          this.searchParam2.startCreatedAt = e[0];
          this.searchParam2.endCreatedAt = e[1];
        } else {
          this.searchParam2.startCreatedAt = "";
          this.searchParam2.endCreatedAt = "";
        }
      } else if (this.activeName == "third") {
        if (e) {
          this.searchParam3.startCreatedAt = e[0];
          this.searchParam3.endCreatedAt = e[1];
        } else {
          this.searchParam3.startCreatedAt = "";
          this.searchParam3.endCreatedAt = "";
        }
      } else {
        if (e) {
          this.searchParam4.startCreatedAt = e[0];
          this.searchParam4.endCreatedAt = e[1];
        } else {
          this.searchParam4.startCreatedAt = "";
          this.searchParam4.endCreatedAt = "";
        }
      }
    },


    async getVerificationCode() {
      let reg = new RegExp(
          "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
      );
      if (!reg.test(this.exportForm.email)) {
        this.$refs.exportForm.validateField("email");
        return false;
      }
      this.getCode();
      this.disabled = true;
      var that = this;

      // 开始获取无痕验证码
      NoTrace.start((nvc) => {
          this.nvc = nvc
      }, this.executeFun, {
          email:that.exportForm.email,
          nvc: '',
          afsVersion: 2
      })
    },
    executeFun (params) {
        let that=this;
        return new Promise(async (resolve, reject) => {
            try {
                let res = await sendMailCode(qs.stringify(params));
                resolve(res)
                if(res.code==200){
                    that.$msg("验证码已发送，请注意接收", "success");
                }
            }catch (err) {
                reject(err)
                clearInterval(interval);
                that.yzmtext = "重新获取";
                that.disabled = false;
                that.currentTime = 60;
            }
        })
    },
    getCode() {
      var that = this;
      var currentTime = that.currentTime;
      interval = setInterval(function () {
        currentTime--;
        that.yzmtext = "(" + currentTime + "s)重新获取";
        if (currentTime <= 0) {
          clearInterval(interval);
          that.yzmtext = "重新获取";
          that.currentTime = 60;
          that.disabled = false;
        }
      }, 1000);
    },
    submitDialogForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          exportRecord(qs.stringify({
            email: that.exportForm.email,
            code: that.exportForm.yzm,
            orderTransactionLogType: 'CONSUME_TS'
          })).then((res) => {
            if (res.code == 200) {
              that.$msg('提交成功', "success");
              that.closeDia();
            }
          }).catch((err) => {
            //that.$msg(err.message,'error',5000);
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeDia(){
        this.exportDialog = false;
        clearInterval(interval);
        this.yzmtext = "重新获取";
        this.currentTime = 60;
        this.disabled = false;
        this.exportForm.yzm='';
    }
  },
};
</script>

<style lang="less" scoped>
.searchBar {
  padding: 20px 0px 10px;

  .el-button {
    margin-left: 13px;
  }
}

</style>
<style lang="less">
.exportDialog {
  .el-dialog__header {
    background: #EEEEEE;
  }

  .el-dialog__body {
    padding-bottom: 0
  }

  p {
    box-sizing: border-box;
    width: 100%;
    padding: 20px;
    background: #FFF9E1;
    color: #F17D44;
    border-radius: 10px;
  }
}

.exportForm {
  padding: 20px;

  .yzm-item {
    .el-form-item__content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .el-input {
        width: 270px;
      }

      .getyzm {
        width: 120px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        background: #fff;
        color: #3f7df7;
        cursor: pointer;
        border: 1px solid #3f7df7;
        font-size: 14px;

        &:hover {
          background: #3f7df7;
          color: #fff;
        }
      }

      .getyzm[disabled] {
        color: #fff;
        background: #bcbcbc;
        pointer-events: none;
        cursor: inherit;
        border-color: #bcbcbc;
      }
    }

    .el-form-item__content::after, .el-form-item__content::before {
      display: none;
    }
  }
}
</style>
